import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import { NgForm } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { SetButtonService } from '../../services/setbuttonvalues.services';

interface ButtonData {
  button_id: number;
  type: string;
  price_label: string;
  price_value: string;
}

@Component({
  selector: 'app-button-value',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css']
})
export class ButtonValueModalComponent implements OnInit {
  public buttonData: ButtonData[] = [];
  public casinoButtonData: ButtonData[] = [];
  public allButtonData: ButtonData[] = [];
  errorMsg: any;
  @ViewChild('formDataForm', { static: false }) formDataForm: NgForm;
  @ViewChild('CasinoformDataForm', { static: false }) CasinoformDataForm: NgForm;
  is_sport:boolean=true;
  is_casino:boolean=false;

  constructor(public dialogRef: MatDialogRef<any>, private http: HttpClient, private setButtonService: SetButtonService, private toastr: ToastrService) { }

  ngOnInit(): void {
    this.getButtondata();
  }

  getButtondata() {
    this.setButtonService.getButtonValueList().subscribe((res: any) => {
      this.allButtonData = res.map((item: any) => ({
        button_id: item.button_id,
        type:item.type,
        price_label: item.price_label || '',
        price_value: item.price_value || ''
      }));
      this.buttonData = this.allButtonData.filter((item:any)=>item.type==='s');
      console.log('this.buttonData',this.buttonData);
      this.casinoButtonData = this.allButtonData.filter((item:any)=>item.type==='c');
      console.log('this.casinoButtonData',this.casinoButtonData);
    });
   

  }

  onSubmit() {
    if (this.formDataForm.valid) {
      const formData = this.buttonData.map(value => ({
        button_id: value.button_id,
        type: value.type,
        price_label: value.price_label,
        price_value: value.price_value
      }));

      this.setButtonService.setButtonValueData(formData).subscribe((res: any) => {
        if (res.errors) {
          this.errorMsg = res.errors;
        } else {
          this.toastr.success('Button successfully Updated');
          this.dialogRef.close();
        }
      });
    }
  }

  onCasinoSubmit() {
    if (this.CasinoformDataForm.valid) {
      const formData = this.casinoButtonData.map(value => ({
        button_id: value.button_id,
        type: value.type,
        price_label: value.price_label,
        price_value: value.price_value
      }));

      this.setButtonService.setButtonValueData(formData).subscribe((res: any) => {
        if (res.errors) {
          this.errorMsg = res.errors;
        } else {
          this.toastr.success('Casino Button successfully Updated');
          this.dialogRef.close();
        }
      });
    }
  }

  changeTab(){
    this.is_casino = !this.is_casino;
    this.is_sport = !this.is_sport;
  }
  closeDialog() {
    this.dialogRef.close();
  }
}
